import { useState, useEffect } from 'react';

const DEFAULT_DELAY = 500;

const useDebounce = (value = '', delay = DEFAULT_DELAY) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

export default useDebounce;
